export default "__VITE_ASSET__BeD3RWkv__"